import { render, staticRenderFns } from "./MyQuizzesDeleteElementsModal.vue?vue&type=template&id=f7676a84&scoped=true&"
import script from "./MyQuizzesDeleteElementsModal.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesDeleteElementsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7676a84",
  null
  
)

export default component.exports